import { render, staticRenderFns } from "./DuplicateDeliverableDetailModal.vue?vue&type=template&id=4decc4b9&"
import script from "./DuplicateDeliverableDetailModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4decc4b9')) {
      api.createRecord('4decc4b9', component.options)
    } else {
      api.reload('4decc4b9', component.options)
    }
    module.hot.accept("./DuplicateDeliverableDetailModal.vue?vue&type=template&id=4decc4b9&", function () {
      api.rerender('4decc4b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateDeliverableDetailModal.vue"
export default component.exports